export const RECAPTCHA_SITE_KEY = '6LeKvwgtAAAAAJBOFd6iDL9Ll9WZxOIk5QrZPPJO';
